// import { Grid } from "@material-ui/core";
// import {
//   Box,
//   Button,
//   Paper,
//   Typography,
//   TextField,
//   InputAdornment,
//   Link,
//   Container,
//   Skeleton,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import LuggageIcon from "@mui/icons-material/Luggage";
// import FlightClassIcon from "@mui/icons-material/FlightClass";
// import axios from "axios";
// import SeatDrawer from "./SeatDrawer";
// import FastfoodIcon from "@mui/icons-material/Fastfood";
// import MealDrawer from "./MealDrawer";
// import BaggageDrawer from "./BaggageDrawer";
// import { toast } from "react-toastify";
// import TravelerDetails from "./TravelerDetails";
// import BookingFlightDetails from "./BookingFlightDetails";
// import BookingFareDetails from "./BookingFareDetails";

// function BookingDetails() {
//   const jwtToken = sessionStorage.getItem("jwtToken");
//   const [mobileNumber, setMobileNumber] = useState("+91 ");
//   const [fareRuleDetail, setFareRuleDetail] = useState("");
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [seatDrawerOpen, setSeatDrawerOpen] = useState(false);
//   const [mealDrawerOpen, setMealDrawerOpen] = useState(false);
//   const [selectedMeals, setSelectedMeals] = useState([]);
//   const [selectedBaggage, setSelectedBaggage] = useState(null);
//   const [selectedSeats, setSelectedSeats] = useState({});

//   const totalBagPrice = selectedBaggage?.Price || 0;

//   const [baggageDrawerOpen, setBaggageDrawerOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [loadingFare, setLoadingFare] = useState(false);
//   const [loadingSsr, setLoadingSsr] = useState(false);
//   const [countries, setCountries] = useState([]);
//   const [selectedCountry, setSelectedCountry] = useState("");
//   const [selectedCountryCode, setSelectedCountryCode] = useState("");
//   const [selectedNationality, setSelectedNationality] = useState("");
//   const [fareQuote, setfareQuote] = useState({});
//   console.log("fareQuote", fareQuote);
//   const [fareQuote2, setfareQuote2] = useState({});
//   console.log("fareQuote2", fareQuote2);
//   const [publishedFare1, setPublishedFare1] = useState(0);

//   const [mealData, setMealData] = useState();
//   const [mealDynamicData, setMealDynamicData] = useState();
//   const [baggageData, setBaggageData] = useState();
//   const [seatDynamicData, setSeatDynamicData] = useState();
//   const [seatPreferenceData, setSeatPreferenceData] = useState();

//   const toggleMealDrawer = (state) => () => {
//     setMealDrawerOpen(state);
//   };

//   const toggleSeatDrawer = (state) => () => {
//     setSeatDrawerOpen(state);
//   };
//   const toggleBaggageDrawer = (state) => () => {
//     setBaggageDrawerOpen(state);
//   };

//   const result = fareQuote.Response?.Results || [];
//   // console.log("Response.Results---", result);

//   const IsLCC = result?.IsLCC;
//   const IsHoldAllowedWithSSR = result?.IsHoldAllowedWithSSR;
//   const IsPassportRequiredAtBook = result?.IsPassportRequiredAtBook;
//   const IsPassportRequiredAtTicket = result?.IsPassportRequiredAtTicket;

//   console.log("IsLCC: ", IsLCC);
//   // console.log("IsHoldAllowedWithSSR: ", IsHoldAllowedWithSSR);
//   // console.log("IsPassportRequiredAtBook: ", IsPassportRequiredAtBook);
//   // console.log("IsPassportRequiredAtTicket: ", IsPassportRequiredAtTicket);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { fdetails, traceId, searchDetails } = location.state || {};

//   const adults = searchDetails.adults;
//   const children = searchDetails.children;
//   const infants = searchDetails.infants;
//   const travelers = searchDetails.travelers;

//   const totalMealPrice = selectedMeals.reduce(
//     (total, meal) => total + meal.Price,
//     0
//   );
//   // const updatedTotalFare = totalFares + totalMealPrice;

//   const publishedFare = (publishedFare1 * travelers).toFixed(0);
//   const totalFares = (
//     publishedFare * 1.11 +
//     totalMealPrice +
//     totalBagPrice
//   ).toFixed(0);
//   const totalTaxes = (totalFares - publishedFare).toFixed(0);

//   const updateSelectedMeals = (meals) => {
//     setSelectedMeals(meals);
//   };

//   const durationCalculator = (source, destination) => {
//     const start = new Date(source);
//     const end = new Date(destination);
//     if (isNaN(start.getTime()) || isNaN(end.getTime())) {
//       return "Invalid Date";
//     }

//     const diffInMs = end.getTime() - start.getTime();

//     const diffInHours = diffInMs / (1000 * 60 * 60);
//     const hours = Math.floor(diffInHours);
//     const minutes = Math.round((diffInHours - hours) * 60);

//     return `${hours} hrs ${minutes} mins`;
//   };

//   const importAllLogos = (requireContext) => {
//     const logos = {};
//     requireContext.keys().forEach((key) => {
//       const airlineCode = key.replace("./", "").replace(".gif", "");
//       logos[airlineCode] = requireContext(key);
//     });
//     return logos;
//   };

//   const airlineLogos = importAllLogos(
//     require.context("../../Assets/Services/Flight/logos", false, /\.gif$/)
//   );

//   const handleInputChange = (event) => {
//     setMobileNumber(event.target.value);
//   };

//   const handleFareRules = async () => {
//     if (!jwtToken) {
//       alert("Authentication token is missing!");
//       return;
//     }

//     const apiUrl = "https://api.ipaisa.co.in/myapp/flight/farerule";
//     const requestBody = {
//       traceId,
//       resultIndex: fdetails.ResultIndex,
//     };
//     setLoading(true);
//     try {
//       const response = await axios.post(apiUrl, requestBody, {
//         headers: {
//           Authorization: `Bearer ${jwtToken}`,
//           "Content-Type": "application/json",
//         },
//       });

//       const { Response } = response.data;

//       if (Response?.Error?.ErrorCode !== 0) {
//         console.warn("API returned an error:", Response.Error?.ErrorMessage);
//         toast.warn(
//           Response.Error?.ErrorMessage || "Failed to retrieve flight details."
//         );
//         return;
//       }

//       if (Response?.FareRules?.length > 0) {
//         const fareRuleDetail = Response.FareRules[0].FareRuleDetail;
//         setFareRuleDetail(fareRuleDetail);
//         setDrawerOpen(true);
//       } else {
//         toast.warn("No fare rules available for this flight.");
//       }
//     } catch (error) {
//       console.error("Error fetching flight details:", error);
//       toast.error("Failed to retrieve flight details. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchFareQuoteAndSSR = async () => {
//       try {
//         setLoadingFare(true);
//         setLoadingSsr(true);

//         const fareQuoteUrl =
//           "https://api.ipaisa.co.in/myapp/flight/farequote";
//         const fareQuotePayload = {
//           traceId: traceId,
//           resultIndex: fdetails.ResultIndex,
//         };

//         const fareQuoteResponse = await axios.post(
//           fareQuoteUrl,
//           fareQuotePayload,
//           {
//             headers: {
//               Authorization: `Bearer ${jwtToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (fareQuoteResponse?.data?.Response?.Error?.ErrorCode === 0) {
//           const apiResponse = fareQuoteResponse.data.Response;
//           const pFare1 =
//             fareQuoteResponse.data.Response.Results.Fare.PublishedFare;

//           setfareQuote(apiResponse);
//           setfareQuote2(apiResponse.Response.Results.Fare);

//           console.log("fareQuote inside api: ", fareQuote);
//           console.log("fareQuote2 inside api: ", fareQuote2);
//           setPublishedFare1(pFare1);

//           // Fetch SSR after Fare Quote is successful
//           setLoadingSsr(true);
//           const ssrUrl = "https://api.ipaisa.co.in/myapp/flight/ssr";
//           const ssrPayload = {
//             traceId: traceId,
//             resultIndex: fdetails.ResultIndex,
//           };

//           const ssrResponse = await axios.post(ssrUrl, ssrPayload, {
//             headers: {
//               Authorization: `Bearer ${jwtToken}`,
//               "Content-Type": "application/json",
//             },
//           });
//           // console.log("ssrResponse", ssrResponse);

//           if (ssrResponse?.data?.Response?.Error?.ErrorCode === 0) {
//             // console.log("SSR API Data", ssrResponse.data);
//             setMealData(ssrResponse?.data?.Response?.Meal || "");
//             setMealDynamicData(ssrResponse?.data?.Response?.MealDynamic || "");
//             setBaggageData(ssrResponse?.data?.Response?.Baggage || "");
//             setSeatDynamicData(ssrResponse?.data?.Response?.SeatDynamic || "");
//             setSeatPreferenceData(
//               ssrResponse?.data?.Response?.SeatPreference || ""
//             );
//           } else {
//             toast.error(
//               ssrResponse.data.Response.Error.ErrorMessage ||
//                 "Session expire, Please try again!"
//             );
//           }
//         } else {
//           toast.error(
//             fareQuoteResponse.data.Response.Error.ErrorMessage ||
//               "Session expire, Please try again!"
//           );
//         }
//       } catch (error) {
//         console.error("Error in API calls:", error);
//         console.log("catch--------")
//       } finally {
//         // Set loading state to false after completing all operations
//         setLoadingFare(false);
//         setLoadingSsr(false);
//       }
//     };

//     fetchFareQuoteAndSSR();
//   }, []);

//   // restcountries
//   useEffect(() => {
//     axios
//       .get("https://restcountries.com/v3.1/all")
//       .then((response) => {
//         const countryData = response.data.map((country) => ({
//           name: country.name.common,
//           code: country.cca2,
//           nationality: country.demonyms?.eng?.f || "N/A",
//         }));
//         const sortedCountries = countryData.sort((a, b) =>
//           a.name.localeCompare(b.name)
//         );
//         setCountries(sortedCountries);
//       })
//       .catch((error) => {
//         console.error("Error fetching countries:", error);
//       });
//   }, []);

//   const handleSelect = (event) => {
//     setSelectedCountry(event.target.value);
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // Get passenger count from search details
//   const passengerCount = searchDetails?.travelers || 1;

//   const handleSeatSelection = (seats) => {
//     setSelectedSeats(seats);
//     // You can also update the total fare here if needed
//   };

//   return (
//     <Container px={3} maxWidth="lg" sx={{ marginTop: "8%" }}>
//       <Box display={"flex"} justifyContent={"space-between"}>
//         <Typography>Service &gt; Flight Booking</Typography>
//         <Link
//           onClick={() => navigate(-1)}
//           sx={{
//             textDecoration: "none",
//             ":hover": {
//               cursor: "pointer",
//             },
//             mt: 0.5,
//             color: "#027BFE",
//           }}
//         >
//           &lt; Back to Search
//         </Link>
//       </Box>

//       <Box mt={2}>
//         <Grid container spacing={4}>
//           <Grid item xs={12} md={9}>
//             {/* Render flight details */}
//             <BookingFlightDetails
//               fdetails={fdetails}
//               handleFareRules={handleFareRules}
//               loading={loading}
//               airlineLogos={airlineLogos}
//               durationCalculator={durationCalculator}
//               fareRuleDetail={fareRuleDetail}
//               drawerOpen={drawerOpen}
//               setDrawerOpen={setDrawerOpen}
//             />

//             <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
//               <Typography
//                 fontWeight={700}
//                 fontSize={"20px"}
//                 fontFamily={"open sans"}
//               >
//                 Traveller Details
//               </Typography>
//               <Typography
//                 fontWeight={300}
//                 fontSize={"14px"}
//                 fontFamily={"open sans"}
//                 mt={1}
//               >
//                 Please make sure you enter the Name and details as per your
//                 Government photo id.
//               </Typography>
//               <Box>
//                 <TravelerDetails
//                   type="adult"
//                   count={adults}
//                   countries={countries}
//                   passportRequired={IsPassportRequiredAtTicket}
//                 />
//                 <TravelerDetails
//                   type="child"
//                   count={children}
//                   countries={countries}
//                   passportRequired={IsPassportRequiredAtTicket}
//                 />
//                 <TravelerDetails
//                   type="infant"
//                   count={infants}
//                   countries={countries}
//                   passportRequired={IsPassportRequiredAtTicket}
//                 />
//               </Box>
//             </Paper>

//             <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
//               <Typography
//                 fontWeight={700}
//                 fontSize={"18px"}
//                 fontFamily={"open sans"}
//               >
//                 Contact Information
//               </Typography>
//               <Typography
//                 fontWeight={300}
//                 fontSize={"14px"}
//                 fontFamily={"open sans"}
//                 mt={2}
//               >
//                 Your ticket and flights information will be sent here..
//               </Typography>

//               <Box
//                 display={"flex"}
//                 flexDirection={"row"}
//                 mt={2}
//                 justifyContent={"space-between"}
//                 gap={2}
//               >
//                 <TextField
//                   fullWidth
//                   label="Mobile Number*"
//                   value={mobileNumber}
//                   onChange={handleInputChange}
//                   InputProps={{
//                     sx: { borderRadius: 3 },
//                     startAdornment: (
//                       <InputAdornment position="start"></InputAdornment>
//                     ),
//                   }}
//                 />
//                 <TextField
//                   InputProps={{ sx: { borderRadius: 3 } }}
//                   fullWidth
//                   label="Email*"
//                 />
//               </Box>
//             </Paper>

//             <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
//               <Typography
//                 fontWeight={700}
//                 fontSize={"18px"}
//                 fontFamily={"open sans"}
//               >
//                 Use GSTIN for this booking (Optional)
//               </Typography>
//               <Typography
//                 fontWeight={300}
//                 fontSize={"14px"}
//                 fontFamily={"open sans"}
//                 mt={2}
//               >
//                 Claim credit of GST charges. Your taxes may get updated post
//                 submitting your GST details
//               </Typography>

//               <Box
//                 display={"flex"}
//                 flexDirection={"row"}
//                 mt={2}
//                 justifyContent={"space-between"}
//                 gap={2}
//               >
//                 <TextField
//                   InputProps={{ sx: { borderRadius: 3 } }}
//                   label="GSTIN"
//                 />
//               </Box>
//             </Paper>
//             {IsLCC && (
//               <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
//                 <Typography
//                   fontWeight={700}
//                   fontSize={"18px"}
//                   fontFamily={"open sans"}
//                 >
//                   Addon Services
//                 </Typography>
//                 {loadingSsr ? (
//                   <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
//                     <Skeleton variant="text" width="100%" height={60} />
//                     <Skeleton variant="text" width="100%" height={60} />
//                     <Skeleton variant="text" width="100%" height={60} />
//                   </Box>
//                 ) : (
//                   <Box mt={2} display={"flex"} flexDirection={"row"} gap={2}>
//                     <Button
//                       onClick={toggleMealDrawer(true)}
//                       variant="outlined"
//                       startIcon={<FastfoodIcon />}
//                       sx={{ color: "#027BFE", textTransform: "none" }}
//                     >
//                       Add Meals{" "}
//                       {selectedMeals.length > 0 && `(${selectedMeals.length})`}
//                     </Button>
//                     <MealDrawer
//                       open={mealDrawerOpen}
//                       onClose={toggleMealDrawer(false)}
//                       onOpen={toggleMealDrawer(true)}
//                       mealData={mealData}
//                       mealDynamicData={mealDynamicData}
//                       selectedMeals={selectedMeals}
//                       updateSelectedMeals={updateSelectedMeals}
//                     />
//                     <Button
//                       onClick={toggleBaggageDrawer(true)}
//                       variant="outlined"
//                       startIcon={<LuggageIcon />}
//                       sx={{ color: "#027BFE", textTransform: "none" }}
//                     >
//                       Add Baggage {selectedBaggage ? "(1)" : ""}
//                     </Button>
//                     <BaggageDrawer
//                       open={baggageDrawerOpen}
//                       onClose={toggleBaggageDrawer(false)}
//                       onOpen={toggleBaggageDrawer(true)}
//                       baggageData={baggageData}
//                       selectedBaggage={selectedBaggage}
//                       setSelectedBaggage={setSelectedBaggage}
//                     />
//                     <Button
//                       onClick={toggleSeatDrawer(true)}
//                       variant="outlined"
//                       startIcon={<FlightClassIcon />}
//                       sx={{ color: "#027BFE", textTransform: "none" }}
//                     >
//                       Seat Selection
//                     </Button>
//                     <SeatDrawer
//                       open={seatDrawerOpen}
//                       onClose={toggleSeatDrawer(false)}
//                       onOpen={toggleSeatDrawer(true)}
//                       seatDynamicData={seatDynamicData}
//                       seatPreferenceData={seatPreferenceData}
//                       passengerCount={passengerCount}
//                       onSeatSelection={handleSeatSelection}
//                     />
//                   </Box>
//                 )}
//               </Paper>
//             )}

//             {/* Continue to Payment */}
//             <Box display={"flex"} justifyContent={"flex-end"} mt={3} mb={4}>
//               <Button
//                 sx={{
//                   background: "#027BFE",
//                   color: "white",
//                   textTransform: "none",
//                   borderRadius: "10px",
//                   px: 4,
//                   py: 1,
//                 }}
//               >
//                 Continue to Payment
//               </Button>
//             </Box>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             {/* Fare Details */}
//             <BookingFareDetails
//               loadingFare={loadingFare}
//               publishedFare={publishedFare}
//               totalTaxes={totalTaxes}
//               totalFares={totalFares}
//               totalMealPrice={totalMealPrice}
//               totalBagPrice={totalBagPrice}
//               // totalFares={updatedTotalFare} // Pass updated fare
//             />
//             {/* Promo code */}
//             {/* <Paper sx={{ p: 2, borderRadius: "10px", mt: 2 }}>
//               <Typography
//                 sx={{
//                   fontFamily: "Open Sans",
//                   fontSize: "16px",
//                   fontWeight: 700,
//                 }}
//               >
//                 Promo code
//               </Typography>
//               <TextField
//                 InputProps={{ sx: { borderRadius: 2 } }}
//                 fullWidth
//                 InputLabelProps={{ shrink: true }}
//                 placeholder="Enter Code"
//                 sx={{
//                   "& .MuiInputBase-root": {
//                     height: { xs: "40px", md: "48px" },
//                   },
//                   mt: 1,
//                 }}
//               />
//               <Button
//                 sx={{
//                   background: "#027BFE",
//                   color: "white",
//                   textTransform: "none",
//                   px: 2,
//                   width: "100px",
//                   borderRadius: "10px",
//                   mt: 1
//                 }}
//               >
//                 Apply
//               </Button>
//             </Paper> */}
//             <img
//               style={{
//                 width: "100%",
//                 height: "250px",
//                 marginTop: "20px",
//                 borderRadius: "10px",
//               }}
//               src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
//               alt="flight_ad"
//             />
//             <img
//               style={{
//                 width: "100%",
//                 height: "250px",
//                 marginTop: "20px",
//                 borderRadius: "10px",
//               }}
//               src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
//               alt="flight_ad"
//             />
//             <img
//               style={{
//                 width: "100%",
//                 height: "250px",
//                 marginTop: "20px",
//                 borderRadius: "10px",
//               }}
//               src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
//               alt="flight_ad"
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     </Container>
//   );
// }

// export default BookingDetails;

import { Grid } from "@material-ui/core";
import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  Link,
  Container,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LuggageIcon from "@mui/icons-material/Luggage";
import FlightClassIcon from "@mui/icons-material/FlightClass";
import axios from "axios";
import SeatDrawer from "./SeatDrawer";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import MealDrawer from "./MealDrawer";
import BaggageDrawer from "./BaggageDrawer";
import { toast } from "react-toastify";
import TravelerDetails from "./TravelerDetails";
import BookingFlightDetails from "./BookingFlightDetails";
import BookingFareDetails from "./BookingFareDetails";

function BookingDetails() {
  const jwtToken = sessionStorage.getItem("jwtToken");
  const [mobileNumber, setMobileNumber] = useState("+91 ");
  const [email, setEmail] = useState('');
  const [fareRuleDetail, setFareRuleDetail] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [seatDrawerOpen, setSeatDrawerOpen] = useState(false);
  const [mealDrawerOpen, setMealDrawerOpen] = useState(false);
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [selectedBaggage, setSelectedBaggage] = useState(null);
  const [selectedSeats, setSelectedSeats] = useState({});
  const totalBagPrice = selectedBaggage?.Price || 0;
  const [baggageDrawerOpen, setBaggageDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingFare, setLoadingFare] = useState(false);
  const [loadingSsr, setLoadingSsr] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("");
  const [fareQuote, setfareQuote] = useState({});
  const [fareQuote2, setfareQuote2] = useState({});
  const [publishedFare1, setPublishedFare1] = useState(0);
  const [mealData, setMealData] = useState();
  const [mealDynamicData, setMealDynamicData] = useState();
  const [baggageData, setBaggageData] = useState();
  const [seatDynamicData, setSeatDynamicData] = useState();
  const [seatPreferenceData, setSeatPreferenceData] = useState();

  const toggleMealDrawer = (state) => () => {
    setMealDrawerOpen(state);
  };

  const toggleSeatDrawer = (state) => () => {
    setSeatDrawerOpen(state);
  };

  const toggleBaggageDrawer = (state) => () => {
    setBaggageDrawerOpen(state);
  };

  const result = fareQuote.Response?.Results || [];
  const IsLCC = fareQuote.data?.Response?.Results?.IsLCC;
  const IsHoldAllowedWithSSR = result?.IsHoldAllowedWithSSR;
  const IsPassportRequiredAtBook = result?.IsPassportRequiredAtBook;
  const IsPassportRequiredAtTicket = result?.IsPassportRequiredAtTicket;

  // console.log("IsHoldAllowedWithSSR: ", IsHoldAllowedWithSSR);

  // console.log("IsPassportRequiredAtBook: ", IsPassportRequiredAtBook);

  // console.log("IsPassportRequiredAtTicket: ", IsPassportRequiredAtTicket);

  const navigate = useNavigate();
  const location = useLocation();

  const { fdetails, traceId, searchDetails } = location.state || {};

  const adults = searchDetails.adults;
  const children = searchDetails.children;
  const infants = searchDetails.infants;

  const travelers = searchDetails.travelers || 1;
  console.log("searchDetails.travelers", searchDetails.travelers);

  const totalMealPrice = selectedMeals.reduce(
    (total, meal) => total + meal.Price,
    0
  );
  // const updatedTotalFare = totalFares + totalMealPrice;
  const passengerCount = searchDetails?.travelers || 1;

  // const updatedTotalFare = totalFares + totalMealPrice;
  console.log("publishedFare1", publishedFare1);
  const publishedFare = (publishedFare1 * travelers).toFixed(0);

  const totalFares = (
    publishedFare * 1.11 +
    totalMealPrice +
    totalBagPrice
  ).toFixed(0);

  const totalTaxes = (totalFares - publishedFare).toFixed(0);
  const travelerTypes = [
    { type: 'adult', count: adults },
    { type: 'child', count: children },
    { type: 'infant', count: infants },
  ];
  const updateSelectedMeals = (meals) => {
    setSelectedMeals(meals);
  };

  const durationCalculator = (source, destination) => {
    const start = new Date(source);
    const end = new Date(destination);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return "Invalid Date";
    }

    const diffInMs = end.getTime() - start.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    const hours = Math.floor(diffInHours);
    const minutes = Math.round((diffInHours - hours) * 60);

    return `${hours} hrs ${minutes} mins`;
  };

  const importAllLogos = (requireContext) => {
    const logos = {};
    requireContext.keys().forEach((key) => {
      const airlineCode = key.replace("./", "").replace(".gif", "");
      logos[airlineCode] = requireContext(key);
    });
    return logos;
  };

  const airlineLogos = importAllLogos(
    require.context("../../Assets/Services/Flight/logos", false, /\.gif$/)
  );

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'mobileNumber') {
      setMobileNumber(value);
    } else if (name === 'email') {
      setEmail(value);
    }
  };

  const handleFareRules = async () => {
    if (!jwtToken) {
      alert("Authentication token is missing!");
      return;
    }

    const apiUrl = "https://api.ipaisa.co.in/myapp/flight/farerule";
    console.log("traceId in booking details--", traceId);

    const requestBody = {
      traceId,
      resultIndex: fdetails.ResultIndex,
    };

    setLoading(true);

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      });

      const { Response } = response.data?.data;

      if (Response?.Error?.ErrorCode !== 0) {
        console.warn("API returned an error:", Response.Error?.ErrorMessage);
        toast.warn(
          Response.Error?.ErrorMessage || "Failed to retrieve flight details."
        );
        return;
      }

      if (Response?.FareRules?.length > 0) {
        const fareRuleDetail = Response.FareRules[0].FareRuleDetail;
        setFareRuleDetail(fareRuleDetail);
        setDrawerOpen(true);
      } else {
        toast.warn("No fare rules available for this flight.");
      }
    } catch (error) {
      console.error("Error fetching flight details:", error);
      toast.error("Failed to retrieve flight details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFareQuoteAndSSR();
  }, []);

  const fetchFareQuoteAndSSR = async () => {
    try {
      setLoadingFare(true);
      setLoadingSsr(true);

      const fareQuoteUrl =
        "https://api.ipaisa.co.in/myapp/flight/farequote";

      const fareQuotePayload = {
        traceId: traceId,
        resultIndex: fdetails.ResultIndex,
      };

      const ssrUrl = "https://api.ipaisa.co.in/myapp/flight/ssr";
      const ssrPayload = {
        traceId: traceId,
        resultIndex: fdetails.ResultIndex,
      };

      const [fareQuoteResponse, ssrResponse] = await Promise.all([
        axios.post(fareQuoteUrl, fareQuotePayload, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }),
        axios.post(ssrUrl, ssrPayload, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }),
      ]);

      const fareData = fareQuoteResponse?.data?.data;
      console.log("Full Fare Quote Response:", fareQuoteResponse.data);

      const isLcc = fareData?.Results?.IsLCC;
      console.log("IsLCC:", fareData.data.Response.Results.IsLCC);

      setfareQuote(fareQuoteResponse.data);
      setfareQuote2(fareData?.Results?.Fare);
      setPublishedFare1(fareData?.Results?.Fare?.PublishedFare);

      const ssrData = ssrResponse?.data?.Response;
      if (ssrData?.Error?.ErrorCode !== 0) {
        console.warn("SSR Error:", ssrData?.Error);
        toast.error(ssrData?.Error?.ErrorMessage || "SSR fetch failed. Please try again.");
        return;
      }

      setMealData(ssrData?.Meal || "");
      setMealDynamicData(ssrData?.MealDynamic || "");
      setBaggageData(ssrData?.Baggage || "");
      setSeatDynamicData(ssrData?.SeatDynamic || "");
      setSeatPreferenceData(ssrData?.SeatPreference || "");

      console.log("Parsed SSR Data:", ssrData);
    } catch (error) {
      console.error("Error in fetchFareQuoteAndSSR:", error);
      toast.error("Something went wrong while fetching data.");
    } finally {
      setLoadingFare(false);
      setLoadingSsr(false);
    }
  };



  useEffect(() => {
    axios
      .get("https://restcountries.com/v3.1/all")
      .then((response) => {
        const countryData = response.data.map((country) => ({
          name: country.name.common,
          code: country.cca2,
          nationality: country.demonyms?.eng?.f || "N/A",
        }));

        const sortedCountries = countryData.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setCountries(sortedCountries);
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
      });
  }, []);

  const handleSelect = (event) => {
    setSelectedCountry(event.target.value);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Get passenger count from search details

  const handleSeatSelection = (seats) => {
    setSelectedSeats(seats);

    // You can also update the total fare here if needed
  };
  console.log("IsLCC: ", IsLCC);
  const [formValues, setFormValues] = useState(null);

  const handleFormSubmit = (values) => {
    const travelersArray = Object.values(values); // Convert object to array
    setFormValues(values.travelers); // not Object.values(values)
    console.log("Form Values:", travelersArray[0]);
    console.log("Form Values:", values);
  };


  const isFormComplete = !!formValues;
  const handleContinueToPayment = async () => {
    if (!formValues || formValues.length === 0) {
      toast.error("Please fill passenger details first.");
      return;
    }

    const jwtToken = sessionStorage.getItem("jwtToken");

    const passengers = formValues.map((traveler, index) => ({
      title: traveler.title,
      firstName: traveler.firstName,
      lastName: traveler.lastName,
      paxType: 1, // default to Adult (you can make this dynamic if needed)
      dateOfBirth: traveler.dob ? new Date(traveler.dob).toISOString() : null,
      gender: Number(traveler.gender), // API expects number
      passportNo: traveler.passportNo,
      passportExpiry: traveler.passportExpiry ? new Date(traveler.passportExpiry).toISOString() : null,
      addressLine1: traveler.addressLine1,
      addressLine2: traveler.addressLine2,
      fare: {
        currency: "INR",
        baseFare: fareQuote?.BaseFare,
        tax: fareQuote?.Tax,
        yQTax: fareQuote?.YQTax,
        additionalTxnFeeOfrd: fareQuote?.AdditionalTxnFeeOfrd,
        additionalTxnFeePub: fareQuote?.AdditionalTxnFeePub,
        otherCharges: fareQuote?.OtherCharges,
        discount: fareQuote?.Discount,
        publishedFare: fareQuote?.PublishedFare,
        offeredFare: fareQuote?.OfferedFare,
        tdsOnCommission: fareQuote?.TdsOnCommission,
        tdsOnPlb: fareQuote?.TdsOnPLB,
        tdsOnIncentive: fareQuote?.TdsOnIncentive,
        serviceFee: fareQuote?.ServiceFee
      },
      city: traveler.city,
      countryCode: traveler.countryCode,
      countryName: traveler.country,
      nationality: traveler.nationality || "IN",
      contactNo: mobileNumber.replace("+91 ", ""),
      email,
      isLeadPax: index === 0
    }));

    const payload = {
      passengers,
      traceId,
      resultIndex: fdetails.ResultIndex
    };

    try {
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/flight/book",
        payload,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json"
          }
        }
      );

      console.log("Booking Response:", response.data);
      toast.success("Booking successful!");
      // Navigate to confirmation page or show booking status

    } catch (error) {
      console.error("Booking Error:", error);
      toast.error("Booking failed. Please try again.");
    }
  };


  console.log("IsLCC: ", IsLCC);

  return (
    <Container px={3} maxWidth="lg" sx={{ marginTop: "8%" }}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography>Service &gt; Flight Booking</Typography>

        <Link
          onClick={() => navigate(-1)}
          sx={{
            textDecoration: "none",
            ":hover": {
              cursor: "pointer",
            },
            mt: 0.5,
            color: "#027BFE",
          }}
        >
          &lt; Back to Search
        </Link>
      </Box>

      <Box mt={2}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={9}>
            {/* Render flight details */}

            <BookingFlightDetails
              fdetails={fdetails}
              handleFareRules={handleFareRules}
              loading={loading}
              airlineLogos={airlineLogos}
              durationCalculator={durationCalculator}
              fareRuleDetail={fareRuleDetail}
              drawerOpen={drawerOpen}
              setDrawerOpen={setDrawerOpen}
            />

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"20px"}
                fontFamily={"open sans"}
              >
                Traveller Details
              </Typography>

              <Typography
                fontWeight={300}
                fontSize={"14px"}
                fontFamily={"open sans"}
                mt={1}
              >
                Please make sure you enter the Name and details as per your
                Government photo id.
              </Typography>

              <Box>
                {travelerTypes.map(({ type, count }) => (
                  <TravelerDetails
                    key={type}
                    type={type}
                    count={count}
                    countries={countries}
                    passportRequired={IsPassportRequiredAtTicket}
                    onFormSubmit={handleFormSubmit}  // Pass the callback to TravelerDetails

                  />
                ))}
              </Box>
            </Paper>

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"18px"}
                fontFamily={"open sans"}
              >
                Contact Information
              </Typography>

              <Typography
                fontWeight={300}
                fontSize={"14px"}
                fontFamily={"open sans"}
                mt={2}
              >
                Your ticket and flights information will be sent here..
              </Typography>

              <Box
                display={"flex"}
                flexDirection={"row"}
                mt={2}
                justifyContent={"space-between"}
                gap={2}
              >
                <TextField
                  fullWidth
                  name="mobileNumber" // ✅ Add this
                  label="Mobile Number*"
                  value={mobileNumber}
                  onChange={handleInputChange}
                  InputProps={{
                    sx: { borderRadius: 3 },

                    startAdornment: (
                      <InputAdornment position="start"></InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  name="email" // ✅ Add this
                  label="Email*"
                  value={email}
                  onChange={handleInputChange}
                  InputProps={{ sx: { borderRadius: 3 } }}
                />

              </Box>
            </Paper>

            <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
              <Typography
                fontWeight={700}
                fontSize={"18px"}
                fontFamily={"open sans"}
              >
                Use GSTIN for this booking (Optional)
              </Typography>

              <Typography
                fontWeight={300}
                fontSize={"14px"}
                fontFamily={"open sans"}
                mt={2}
              >
                Claim credit of GST charges. Your taxes may get updated post
                submitting your GST details
              </Typography>

              <Box
                display={"flex"}
                flexDirection={"row"}
                mt={2}
                justifyContent={"space-between"}
                gap={2}
              >
                <TextField
                  InputProps={{ sx: { borderRadius: 3 } }}
                  label="GSTIN"
                />
              </Box>
            </Paper>

            {IsLCC && (
              <Paper sx={{ mt: 3, p: 2, borderRadius: 3 }}>
                <Typography
                  fontWeight={700}
                  fontSize={"18px"}
                  fontFamily={"open sans"}
                >
                  Addon Services
                </Typography>

                {loadingSsr ? (
                  <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                    <Skeleton variant="text" width="100%" height={60} />
                    <Skeleton variant="text" width="100%" height={60} />
                    <Skeleton variant="text" width="100%" height={60} />
                  </Box>
                ) : (
                  <Box mt={2} display={"flex"} flexDirection={"row"} gap={2}>
                    <Button
                      onClick={toggleMealDrawer(true)}
                      variant="outlined"
                      startIcon={<FastfoodIcon />}
                      sx={{ color: "#027BFE", textTransform: "none" }}
                    >
                      Add Meals{" "}
                      {selectedMeals.length > 0 && `(${selectedMeals.length})`}
                    </Button>

                    <MealDrawer
                      open={mealDrawerOpen}
                      onClose={toggleMealDrawer(false)}
                      onOpen={toggleMealDrawer(true)}
                      mealData={mealData}
                      mealDynamicData={mealDynamicData}
                      selectedMeals={selectedMeals}
                      updateSelectedMeals={updateSelectedMeals}
                    />

                    <Button
                      onClick={toggleBaggageDrawer(true)}
                      variant="outlined"
                      startIcon={<LuggageIcon />}
                      sx={{ color: "#027BFE", textTransform: "none" }}
                    >
                      Add Baggage {selectedBaggage ? "(1)" : ""}
                    </Button>

                    <BaggageDrawer
                      open={baggageDrawerOpen}
                      onClose={toggleBaggageDrawer(false)}
                      onOpen={toggleBaggageDrawer(true)}
                      baggageData={baggageData}
                      selectedBaggage={selectedBaggage}
                      setSelectedBaggage={setSelectedBaggage}
                    />

                    <Button
                      onClick={toggleSeatDrawer(true)}
                      variant="outlined"
                      startIcon={<FlightClassIcon />}
                      sx={{ color: "#027BFE", textTransform: "none" }}
                    >
                      Seat Selection
                    </Button>

                    <SeatDrawer
                      open={seatDrawerOpen}
                      onClose={toggleSeatDrawer(false)}
                      onOpen={toggleSeatDrawer(true)}
                      seatDynamicData={seatDynamicData}
                      seatPreferenceData={seatPreferenceData}
                      passengerCount={passengerCount}
                      onSeatSelection={handleSeatSelection}
                    />
                  </Box>
                )}
              </Paper>
            )}

            {/* Continue to Payment */}
            <Box display={"flex"} justifyContent={"flex-end"} mt={3} mb={4}>
              <Button
                sx={{
                  background: "#027BFE",
                  color: "white",
                  textTransform: "none",
                  borderRadius: "10px",
                  px: 4,
                  py: 1,
                }}
                disabled={!isFormComplete}  // Disable button if form is not complete
                onClick={handleContinueToPayment}
              >
                Continue to Payment
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} md={3}>
            {/* Fare Details */}
            <BookingFareDetails
              loadingFare={loadingFare}
              publishedFare={publishedFare}
              totalTaxes={totalTaxes}
              totalFares={totalFares}
              totalMealPrice={totalMealPrice}
              totalBagPrice={totalBagPrice}
            // totalFares={updatedTotalFare} // Pass updated fare
            />
            <img
              style={{
                width: "100%",

                height: "250px",

                marginTop: "20px",

                borderRadius: "10px",
              }}
              src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
              alt="flight_ad"
            />
            <img
              style={{
                width: "100%",

                height: "250px",

                marginTop: "20px",

                borderRadius: "10px",
              }}
              src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
              alt="flight_ad"
            />
            <img
              style={{
                width: "100%",

                height: "250px",

                marginTop: "20px",

                borderRadius: "10px",
              }}
              src="https://i.pinimg.com/originals/cc/a5/02/cca5022c86f67861746d7cf2eb486de8.gif"
              alt="flight_ad"
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default BookingDetails;
